function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScreenshot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 56 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.53,14.032L19.812,16.187L14.654,16.187C12.216,16.187 10.234,18.168 10.234,20.606L10.234,38.283C10.234,40.721 12.216,42.703 14.654,42.703L41.17,42.703C43.607,42.703 45.589,40.721 45.589,38.283L45.589,20.606C45.589,18.168 43.607,16.187 41.17,16.187L36.012,16.187L35.293,14.032C34.845,12.679 33.581,11.767 32.152,11.767L23.672,11.767C22.242,11.767 20.979,12.679 20.53,14.032ZM27.912,36.074C24.252,36.074 21.283,33.104 21.283,29.445C21.283,25.785 24.252,22.816 27.912,22.816C31.571,22.816 34.541,25.785 34.541,29.445C34.541,33.104 31.571,36.074 27.912,36.074Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.916,2.704C16.916,1.211 15.706,0 14.212,0C11.85,0 8.348,0 5.412,0C2.423,-0 0,2.423 0,5.412C0,5.413 0,5.413 0,5.413C0,5.413 9.435,5.413 14.212,5.413C15.706,5.413 16.916,4.203 16.916,2.709C16.916,2.707 16.916,2.706 16.916,2.704Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.709,16.916C4.203,16.916 5.413,15.706 5.413,14.212C5.413,9.435 5.413,0 5.413,0L5.412,0C2.423,0 -0,2.423 -0,5.412C-0,8.348 0,11.85 -0,14.212C0,15.706 1.211,16.916 2.704,16.916C2.706,16.916 2.707,16.916 2.709,16.916Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.907,2.704C38.907,1.211 40.118,0 41.611,0C43.974,0 47.475,0 50.411,0C53.4,-0 55.823,2.423 55.823,5.412C55.823,5.413 55.823,5.413 55.823,5.413C55.823,5.413 46.389,5.413 41.611,5.413C40.118,5.413 38.907,4.203 38.907,2.709C38.907,2.707 38.907,2.706 38.907,2.704Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.114,16.916C51.621,16.916 50.41,15.706 50.41,14.212C50.41,9.435 50.41,0 50.41,0L50.411,0C53.4,0 55.823,2.423 55.823,5.412C55.823,8.348 55.823,11.85 55.823,14.212C55.823,15.706 54.613,16.916 53.119,16.916C53.118,16.916 53.116,16.916 53.114,16.916Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.916,51.766C16.916,53.259 15.706,54.47 14.212,54.47C11.85,54.47 8.348,54.47 5.412,54.47C2.423,54.47 0,52.047 0,49.058C0,49.057 0,49.057 0,49.057C0,49.057 9.435,49.057 14.212,49.057C15.706,49.057 16.916,50.268 16.916,51.761C16.916,51.763 16.916,51.764 16.916,51.766Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.709,37.554C4.203,37.554 5.413,38.765 5.413,40.258C5.413,45.035 5.413,54.47 5.413,54.47C5.413,54.47 5.413,54.47 5.412,54.47C2.423,54.47 -0,52.047 -0,49.058C-0,46.122 0,42.62 -0,40.258C0,38.765 1.211,37.554 2.704,37.554C2.706,37.554 2.707,37.554 2.709,37.554Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.907,51.766C38.907,53.259 40.118,54.47 41.611,54.47C43.974,54.47 47.475,54.47 50.411,54.47C53.4,54.47 55.823,52.047 55.823,49.058C55.823,49.057 55.823,49.057 55.823,49.057C55.823,49.057 46.389,49.057 41.611,49.057C40.118,49.057 38.907,50.268 38.907,51.761C38.907,51.763 38.907,51.764 38.907,51.766Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.114,37.554C51.621,37.554 50.41,38.765 50.41,40.258C50.41,45.035 50.41,54.47 50.41,54.47C50.41,54.47 50.411,54.47 50.411,54.47C53.4,54.47 55.823,52.047 55.823,49.058C55.823,46.122 55.823,42.62 55.823,40.258C55.823,38.765 54.613,37.554 53.119,37.554C53.118,37.554 53.116,37.554 53.114,37.554Z",
    style: {
      fill: "white"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScreenshot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/screenshot.afe5d93242ba540111a8f1fa9555ca9b.svg";